export interface Category {
  id: number;
  name: string;
  url: string;
  imageSeq: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 911,
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageSeq: "cat-shoes-01",
    description: "Najlepsze obuwie w jednym miejscu",
  },
  {
    id: 912,
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    imageSeq: "cat-hoodies-02",
    description: "Bluzy i swetry na każdą porę roku",
  },
  {
    id: 913,
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    imageSeq: "cat-tshirts-03",
    description: "Koszulki w najlepszych cenach",
  },
  {
    id: 914,
    name: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    imageSeq: "cat-jackets-04",
    description: "Kurtki i płaszcze – styl i wygoda",
  },
  {
    id: 915,
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    imageSeq: "cat-pants-05",
    description: "Spodnie i szorty na każdą okazję",
  },
  {
    id: 916,
    name: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    imageSeq: "cat-headwear-06",
    description: "Czapki i nakrycia głowy",
  },
  {
    id: 917,
    name: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    imageSeq: "cat-sets-07",
    description: "Komplety i zestawy ubrań",
  },
  {
    id: 918,
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    imageSeq: "cat-underwear-08",
    description: "Bielizna i odzież podstawowa",
  },
  {
    id: 919,
    name: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    imageSeq: "cat-jersey-09",
    description: "Koszulki sportowe i klubowe",
  },
  {
    id: 920,
    name: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    imageSeq: "cat-accessories-10",
    description: "Akcesoria, które dopełnią styl",
  },
  {
    id: 921,
    name: "Bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    imageSeq: "cat-bags-11",
    description: "Torby i plecaki – funkcjonalność",
  },
  {
    id: 922,
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    imageSeq: "cat-belts-12",
    description: "Paski i dodatki skórzane",
  },
  {
    id: 923,
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    imageSeq: "cat-perfumes-13",
    description: "Zapachy i perfumy światowych marek",
  },
  {
    id: 924,
    name: "OtherStuff",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    imageSeq: "cat-other-14",
    description: "Pozostałe produkty i okazje",
  },
];